import React, { useEffect, useRef, useState } from "react";

export default function LazyRecaptcha(props) {
  const wrapperRef = useRef(null);
  const [shouldLoad, setShouldLoad] = useState(false);
  const [RecaptchaComponent, setRecaptchaComponent] = useState(null);

  useEffect(() => {
    if (shouldLoad) return;

    const wrapper = wrapperRef.current;
    if (!wrapper || typeof IntersectionObserver === "undefined") {
      setShouldLoad(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShouldLoad(true);
          observer.disconnect();
        }
      },
      { rootMargin: "0px" }
    );

    observer.observe(wrapper);

    return () => observer.disconnect();
  }, [shouldLoad]);

  useEffect(() => {
    let isMounted = true;

    if (shouldLoad && !RecaptchaComponent) {
      import("react-google-recaptcha").then((module) => {
        if (isMounted) {
          setRecaptchaComponent(() => module.default);
        }
      });
    }

    return () => {
      isMounted = false;
    };
  }, [RecaptchaComponent, shouldLoad]);

  return (
    <div ref={wrapperRef}>
      {RecaptchaComponent && <RecaptchaComponent {...props} />}
    </div>
  );
}
